import React from "react";
import IPortfolioPage from "./IPortfolioPage";
import Header from "@appComponents/Header/Header";
import WhitePaper from "@appComponents/WhitePaper/WhitePaper";
import MyEquityCompanies from "@portfolio/components/MyEquityCompanies/MyEquityCompanies";
import * as style from "./PortfolioPageStyle.module.scss";
import Overview from "@portfolio/components/Overview/Overview";
import EquityHistory from "@portfolio/components/EquityHistory/EquityHistory";

import * as pages from "@appStyles/pages.module.scss";
export default class PortfolioPage extends React.Component<IPortfolioPage> {
  render() {
    return (
      <>
        <Header padding={"50 20"}>
          <div
            className={`${pages.headerContent} ${pages.headerContentColumn}`}
          >
            <Overview />
            <hr className={pages.separator} />
            <MyEquityCompanies />
          </div>
        </Header>
        <div className={style.portfolioPage}>
          <EquityHistory />
        </div>
      </>
    );
  }
}
